export const FEE_CATEGORY_PERMISSIONS = {
  view: 'FEE_CATEGORIES',
  create: 'FEE_CATEGORY_ADD',
  edit: 'FEE_CATEGORY_EDIT',
  delete: 'FEE_CATEGORY_DELETE',
  import: 'FEE_CATEGORY_IMPORT',
} as const;

export const APARTMENT_PERMISSIONS = {
  view: 'APARTMENT_LIST',
  create: 'APARTMENT_ADD',
  edit: 'APARTMENT_EDIT',
  delete: 'APARTMENT_DELETE',
  import: 'APARTMENT_IMPORT',
} as const;

export const ACCOUNT_PERMISSIONS = {
  view: 'ACCOUNT_LIST',
  create: 'ACCOUNT_ADD',
  edit: 'ACCOUNT_EDIT',
  delete: 'ACCOUNT_DELETE',
} as const;

export const BUILDING_BANNER_PERMISSIONS = {
  view: 'BUILDING_BANNER_LIST',
  create: 'BUILDING_BANNER_ADD',
  edit: 'BUILDING_BANNER_EDIT',
  delete: 'BUILDING_BANNER_DELETE',
} as const;

export const BUILDING_NEWS_PERMISSIONS = {
  view: 'BUILDING_NEWS_LIST',
  create: 'BUILDING_NEWS_ADD',
  edit: 'BUILDING_NEWS_EDIT',
  delete: 'BUILDING_NEWS_DELETE',
} as const;

export const BUILDING_UTILITY_PERMISSIONS = {
  view: 'BUILDING_UTILITY_LIST',
  create: 'BUILDING_UTILITY_ADD',
  edit: 'BUILDING_UTILITY_EDIT',
  delete: 'BUILDING_UTILITY_DELETE',
} as const;

export const BUILDING_UTILITY_GROUP_PERMISSIONS = {
  view: 'BUILDING_UTILITY_GROUPS',
  create: 'BUILDING_UTILITY_GROUP_ADD',
  edit: 'BUILDING_UTILITY_GROUP_EDIT',
  delete: 'BUILDING_UTILITY_GROUP_DELETE',
} as const;

export const BUILDING_UTILITY_BOOKING_PERMISSIONS = {
  view: 'BUILDING_UTILITY_BOOKINGS',
  create: 'BUILDING_UTILITY_BOOKING_ADD',
  edit: 'BUILDING_UTILITY_BOOKING_EDIT',
  delete: 'BUILDING_UTILITY_BOOKING_DELETE',
} as const;

export const CONSTRUCTION_REGISTRATION_PERMISSIONS = {
  view: 'CONSTRUCTION_REGISTRATION',
  create: 'CONSTRUCTION_REGISTRATION_ADD',
  edit: 'CONSTRUCTION_REGISTRATION_EDIT',
} as const;

export const ENTRY_EXIT_REGISTRATION_PERMISSIONS = {
  view: 'ENTRY_EXIT_REGISTRATION',
  create: 'ENTRY_EXIT_REGISTRATION_ADD',
  edit: 'ENTRY_EXIT_REGISTRATION_EDIT',
} as const;

export const MOVING_REGISTRATION_PERMISSIONS = {
  view: 'MOVING_REGISTRATION',
  create: 'MOVING_REGISTRATION_ADD',
  edit: 'MOVING_REGISTRATION_EDIT',
} as const;

export const TASK_PERMISSIONS = {
  view: 'TASK_LIST',
  create: 'TASK_ADD',
} as const;

export const REVENUE_CONTRACT_PERMISSIONS = {
  view: 'REVENUE_CONTRACTS',
  deleteInvoice: 'REVENUE_CONTRACTS_DELETE',
} as const;
